import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import { toKebabCase } from 'utils/text'

import type { ReactNode } from 'react'

import ArrowRight from 'assets/icons/arrow-alt-right-dark.svg'

export interface PostTestCardProps {
  href: string
  title: string
  description: string
  isLocked: boolean
  icon?: ReactNode
  trackStep?: () => void
  isActive?: boolean
}

const PostTestCard = ({
  title,
  description,
  href,
  isLocked = true,
  icon,
  trackStep = () => {},
  isActive = false,
}: PostTestCardProps) => {
  return (
    <div className={clsx('flex-grow flex-shrink rounded')}>
      <div
        className={clsx([
          'relative',
          'min-h-[70px] p-3 w-full',
          'border border-subdued',
          isActive ? 'bg-[#0B5FEF] ' : 'bg-white',
          isLocked ? 'rounded-t-lg' : 'rounded-lg',
        ])}
      >
        <div className={clsx('flex items-center')}>
          {icon}
          <div className="ml-3">
            {!isLocked ? (
              <Link href={href} passHref>
                <a
                  data-step-type={toKebabCase(title)}
                  onClick={trackStep}
                  href={href}
                  className={clsx(
                    'overlay-link block font-bold',
                    isActive ? 'text-white' : 'text-type-basic-dark'
                  )}
                >
                  {title}
                </a>
              </Link>
            ) : (
              <Text variant="heading-sm" className="overlay-link block">
                {title}
              </Text>
            )}
            <div className="pr-2">
              <Text variant="body-sm" color={isActive ? 'inverse' : 'disabled'}>
                {description}
              </Text>
            </div>
          </div>
          <div className="ml-auto">
            <ArrowRight color="inverse" />
          </div>
        </div>
      </div>
      {isLocked && (
        <div
          className={clsx(
            'flex items-center px-3 py-2  rounded-b-lg',
            isActive ? 'bg-[#0B5FEF]' : 'bg-surface-neutral-default'
          )}
        >
          <Icon className="mr-3">lock</Icon>
          <Text variant="body-sm">Pelajari materi di atas terlebih dahulu</Text>
        </div>
      )}
    </div>
  )
}

export default PostTestCard
